import React from 'react';
import { RETENTION } from '../../data/content';
import SectionHeader from '../SectionHeader';
import { useIntersection } from '../../hooks/useIntersection';
import { useCountUp } from '../../hooks/useCountUp';

function BigNum({ value, suffix, format, label, sub, trigger }) {
  const display = useCountUp(value, format, '', suffix, trigger);
  return (
    <div className="r25-big-num" style={{ textAlign: 'center', background: 'var(--gpale)', borderRadius: 14, padding: '52px 32px', border: '1px solid rgba(47,158,92,0.12)' }}>
      <div style={{ fontFamily: 'var(--serif)', fontSize: 'inherit', color: 'var(--g2)', lineHeight: 1, marginBottom: 8, fontWeight: 600 }}>{display}</div>
      <div style={{ fontSize: 18, color: 'var(--ink)', fontWeight: 500, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 13, color: 'var(--gray)' }}>{sub}</div>
    </div>
  );
}

export default function Retention() {
  const { ref, visible } = useIntersection();
  return (
    <section id="retention" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={RETENTION.sectionNum} title={RETENTION.title} titleEm={RETENTION.titleEm} body={RETENTION.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''} r25-retention-grid`}
          style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: 40, alignItems: 'center' }}>
          <BigNum {...RETENTION.bigNum} trigger={visible} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {RETENTION.points.map((p, i) => (
              <div key={i} style={{ padding: '15px 18px', background: 'var(--gray-lt)', borderRadius: 8, borderLeft: '3px solid var(--g2)' }}>
                <div style={{ fontFamily: 'var(--serif)', fontSize: 22, color: 'var(--g2)', marginBottom: 2, fontWeight: 600 }}>{p.val}</div>
                <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink)' }}>{p.label}</div>
                <div style={{ fontSize: 12, color: 'var(--gray)' }}>{p.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
